import { FormatConfig } from '@y42/model';
import { ConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { ColorByArea } from './sub-models/color.model';
import { DatosAxisPointer } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';
import { TooltipModel } from './sub-models/tooltip.model';

export class FunnelSettingsModel extends BaseEchartsSettingsModel<FunnelSeriesModel> {
  constructor(
    public gap = 1,
    public conditionalFormattingRules?: ConditionalFormattingRule[],
    public colorBy?: {
      area: ColorByArea;
      hiddenValues: Record<string, boolean>;
    },
    series: FunnelSeriesModel[] = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    breakdowns?: fieldId[],
  ) {
    super(series, show_legend, axisPointer, [], breakdowns);
  }
}

export class FunnelSeriesModel {
  constructor(
    public field_id: fieldId | null = null,
    public format = 'inherit',
    public formatConfig?: FormatConfig,
    public label: LabelModel = new LabelModel(),
    public mark: MarkTypeEnum = MarkTypeEnum.Bar,
    public stack_name = 1, // need as unique id
    public tooltip: TooltipModel = new TooltipModel(),
    public show_right_axis = false,
  ) {}
}
